//React Components
import React, { useState, useEffect } from "react";

//Material Ui Components
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import StepLabel from '@material-ui/core/StepLabel';
import SettingsIcon from '@material-ui/icons/Settings';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import VideoLabelIcon from '@material-ui/icons/VideoLabel';
import clsx from 'clsx';

//Global components and images
import Company_icon from "../../Assets/companyIconWhite.png";
import Team_icon from "../../Assets/teamIconWhite.png";
import Site_icon from "../../Assets/SiteIconWhite.png";
import Workflow_icon from "../../Assets/workflow.png";
import Plan_icon from "../../Assets/planIconWhite.png";
import arrow from "../../Assets/arrow.png";
import Colors from "../../Global/colors";
import GlobalApi from "../../Global";
import refresh_token from "../../Global/refresh_token";

import companyN from "../../Assets/Onboarding/company_gray.png"
import planN from "../../Assets/Onboarding/plan_gray.png"
import siteN from "../../Assets/Onboarding/sites_gray.png"
import teamN from "../../Assets/Onboarding/team_gray.png"
import workflowN from "../../Assets/Onboarding/workflow_gray.png"
import companyG from "../../Assets/Onboarding/company_O.png"
import planG from "../../Assets/Onboarding/plan_O.png"
import siteG from "../../Assets/Onboarding/sites_O.png"
import teamG from "../../Assets/Onboarding/team_O.png"
import workflowG from '../../Assets/Onboarding/workflow_O.png'


//Custom Components
import Sites from '../sites/sites';
import Team from '../newTeam/team';
import Company from '../Company/company';
import Workflow from '../workflow/hierarchy';
import PlanUrAudits from '../planYourAudit/planYourAudits';
import NotPermitted from '../notPermitted/notPermitted'


//Redux
import { useSelector, useDispatch } from "react-redux";

// CSS style
import "./onbording.css"


//Styles
const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: 'white',
      zIndex: 1,
      color: '#fff',
      width: 60,
      height: 60,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
    },
    root2: {
      backgroundColor: 'white',
      zIndex: 1,
      color: '#fff',
      width: 40,
      height: 40,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
      boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
    },
    active: {
      backgroundColor: 'white',
      boxShadow: '0 2px 5px 0 rgba(0,0,0,.25)',
    },
    completed: {
      backgroundImage:
        'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    },
  });


function Onbording() {
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState({});
  const [permissions_obj, setPermissionObj] = useState({});
  const steps = getSteps();

  let userData = useSelector((state) => state.userReducer.user);
  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      getPermissions()
    },
    [company?.id]
  );
  
  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);

          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  function getSteps() {
    return [
      "Company",
      "Team",
      "Site",
      "Workflow",
      "Plan Inspection"
    ];
  }
  
  
  
  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        if(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Company Management"] == true){
          return <Company isOnboarding={true}/>;
        }else{
          return <div style={{backgroundColor: Colors.globalColor9, borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding:'20px 1px 20px 20px'}}><NotPermitted/></div>;
        }
      case 1:
        if(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true){
          return <Team isOnboarding={true}/>;
        }else{
          return <div style={{backgroundColor: Colors.globalColor9, borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding:'20px 1px 20px 20px'}}><NotPermitted/></div>;
        }
      case 2:
        return <Sites isOnboarding={true}/>;
      case 3:
        if(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Workflow"] == true){
          return <Workflow isOnboarding={true}/>;
        }else{
          return <div style={{backgroundColor: Colors.globalColor9, borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding:'20px 1px 20px 20px'}}><NotPermitted/></div>;
        }
      case 4:
        if(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["Template Creation"] == true){
          return <PlanUrAudits isOnboarding={true}/>;
        }else{
          return <div style={{backgroundColor: Colors.globalColor9, borderRadius: "10px", boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding:'20px 1px 20px 20px'}}><NotPermitted/></div>;
        }
      default:
        return "Unknown stepIndex";
    }
  }
  
  function ColorlibStepIcon(props) {
      const classes = useColorlibStepIconStyles();
      const { active, completed } = props;
    
      const icons = { 1: <img src={active ? companyG : companyN} width={35} />, 2: <img src={active ? teamG : teamN} width={35} />, 3: <img src={active ? siteG : siteN} width={35} />, 4: <img src={active ? workflowG : workflowN} width={35} />, 5: <img src={active ? planG : planN} width={35} /> };
    
      return (
        <div
          className={clsx(classes.root, {
            [classes.active]: active,
            [classes.completed]: completed,
          })}
        >
          {icons[String(props.icon)]}
        </div>
      );
    }
  

    function ColorlibStepIcon2(props) {
      const classes = useColorlibStepIconStyles();
      const { active, completed } = props;
    
      const icons = { 1: <img src={active ? companyG : companyN} width={25} />, 2: <img src={active ? teamG : teamN} width={25} />, 3: <img src={active ? siteG : siteN} width={25} />, 4: <img src={active ? workflowG : workflowN} width={25} />, 5: <img src={active ? planG : planN} width={25} /> };
    
      return (
        <div
        style={{margin:'0px'}}
          className={clsx(classes.root2, {
            [classes.active]: active,
            [classes.completed]: completed,
          })}
        >
          {icons[String(props.icon)]}
        </div>
      );
    }




  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[activeStep] = true;
    setCompleted(newCompleted);
    handleNext();
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  return <div style={{ width: "100%", minHeight: "80vh", padding: "10px", overflowY: "scroll", backgroundColor:Colors.globalColor9, justifyContent:"center", alignItems:'center' }}>
      {window.innerWidth > 700 && <Stepper nonLinear activeStep={activeStep}>
        {steps.map((label, index) => <Step key={label} onClick={handleStep(index)} completed={completed[index]}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{""}</StepLabel>
              <p className="stepTitle">{label}</p>
            </Step>)
          //         <Step key={label} className="onbordingStep">
          //           <StepButton  className={clsx(classes.root, {
          //     [classes.completed]: completed,
          //   })}/>
          //           <p>{label}</p>
          //         </Step>
        }
      </Stepper>}

      {window.innerWidth > 500 && window.innerWidth <= 700 && <Stepper nonLinear activeStep={activeStep} style={{padding:'0px'}}>
        {steps.map((label, index) => <Step key={label} onClick={handleStep(index)} completed={completed[index]}>
              <StepLabel StepIconComponent={ColorlibStepIcon}>{""}</StepLabel>
              <p className="stepTitle" style={{fontSize:'12px'}}>{label}</p>
            </Step>)
          //         <Step key={label} className="onbordingStep">
          //           <StepButton  className={clsx(classes.root, {
          //     [classes.completed]: completed,
          //   })}/>
          //           <p>{label}</p>
          //         </Step>
        }
      </Stepper>}

      {window.innerWidth <= 500 && 
      <Stepper className="mobileStepper" nonLinear activeStep={activeStep} style={{padding:'0px'}}>
        {steps.map((label, index) => <Step key={label} onClick={handleStep(index)} completed={completed[index]}>
              <StepLabel StepIconComponent={ColorlibStepIcon2}>{""}</StepLabel>
              {label == "Plan Inspection" ? <p className="stepTitle" style={{fontSize:'10px'}}>{"Plan..."}</p> : <p className="stepTitle" style={{fontSize:'10px'}}>{label}</p>}
            </Step>)
          //         <Step key={label} className="onbordingStep">
          //           <StepButton  className={clsx(classes.root, {
          //     [classes.completed]: completed,
          //   })}/>
          //           <p>{label}</p>
          //         </Step>
        }
      </Stepper>}
      <div>
        {allStepsCompleted() ? <div>
            <Typography>
              All steps completed - you&apos;re finished
            </Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div> : <div>
            <Typography>{getStepContent(activeStep)}</Typography>
            {/* <div>
              {activeStep !== steps.length && (completed[activeStep] ? <Typography variant="caption">
                    Step {activeStep + 1} already completed
                  </Typography> : <Button variant="contained" color="primary" onClick={handleComplete}>
                    {completedSteps() === totalSteps() - 1 ? "Finish" : "Complete Step"}
                  </Button>)}
            </div> */}
          </div>}
      </div>
    </div>;
}

export default Onbording;
